import { cn } from '@/shared/utils/cn'

interface BadgeProps {
  count?: number
  className?: string
}

export function Badge({ count, className }: BadgeProps) {
  if (!count) return null
  return (
    <span
      className={cn(
        'inline-flex h-5 min-w-5 items-center justify-center rounded-full bg-danger px-1 py-0 text-[10px] font-bold leading-none text-white',
        className,
      )}
    >
      {count > 99 ? '99+' : count}
    </span>
  )
}
